import { useMemo } from 'react';
import algoliasearch from 'algoliasearch/lite';
import { InstantSearch } from 'react-instantsearch';
import { CLIENT_ID, CLIENT_KEY, SEARCH_INDEX } from '@components/Search/const';
import { PUBLICATION_FLAG } from '@config/index';
import { WindowType } from '@typescript/index';
import { getRegion } from '@utils/misc';
import getPublicEnv from '@utils/getPublicEnv';
import AlgoliaRecommendedProductsContent from '@features/productPreview/sections/AlgoliaRecommendedProducts/AlgoliaRecommendedProductsContent';
const PAGE_SIZE_ON_MOBILE = 4;
const PAGE_SIZE_ON_DESKTOP = 8;
type PropsType = {
  mainProductID: number;
  windowType: WindowType;
};
const AlgoliaRecommendedProducts = ({
  mainProductID,
  windowType
}: PropsType) => {
  const searchClient = useMemo(() => algoliasearch(CLIENT_ID, CLIENT_KEY), []);
  const region = getRegion('lowercase');
  const publicationFlag = PUBLICATION_FLAG || getPublicEnv('NEXT_PUBLIC_PUBLICATION_FLAG');
  const indexName = `${publicationFlag}_${region}_${SEARCH_INDEX.products}`;
  const isSmallerThanDesktop = windowType === WindowType.mobile || windowType === WindowType.tablet;
  const limit = isSmallerThanDesktop ? PAGE_SIZE_ON_MOBILE : PAGE_SIZE_ON_DESKTOP;
  if (!mainProductID) return null;
  return <InstantSearch searchClient={searchClient} indexName={indexName} future={{
    preserveSharedStateOnUnmount: false
  }} insights>
      <AlgoliaRecommendedProductsContent objectIDs={[String(mainProductID)]} limit={limit} />
    </InstantSearch>;
};
export default AlgoliaRecommendedProducts;